import {Component, Input, OnInit} from '@angular/core';
import {DOutDescription} from "../../digitalout/digitalOutDescription";
import {DOState} from "../../digitalout/digitalOutStatus";
import {DigitaloutlistComponent} from "../../digitalout/digtaloutlist/digitaloutlist.component";
import {cIOMAPPEDFREQUENCY} from "../frequencyStatus";
import {FrequencylistComponent} from "../frequencylist/frequencylist.component";

@Component({
  selector: 'app-frequencydetails',
  templateUrl: './frequencydetails.component.html',
  styleUrls: ['./frequencydetails.component.css']
})
export class FrequencydetailsComponent implements OnInit {
  @Input()
  refNumber: number = -1;
  fqStatus: cIOMAPPEDFREQUENCY;
  used: string = "";
  status: string = "";

  constructor(private frequencylistComponent: FrequencylistComponent) {

    this.fqStatus = new cIOMAPPEDFREQUENCY();
    frequencylistComponent.Add(this);
  }

  UpdateFqState(fqState: cIOMAPPEDFREQUENCY): void
  {
    this.fqStatus = fqState;
    this.used = (this.fqStatus.inuse) ? "used" : "free";
    this.status = this.GetStatusAsString(this.fqStatus.status);
  }


  GetStatusAsString(statusIn: number): string{
    switch (statusIn)
    {
      case 0: return "NOT CONN";
      case 1: return "RESERVED";
      case 2: return "NO PULSE";
      case 3: return "UNDERFLOW";
      case 4: return "OK";
      case 255: return "OVERFLOW";
      default: return "Unknown";
    }
  }


  ngOnInit(): void {
  }

}
